import { RefObject } from 'react';
import { IToastManager, ToastIdentifier, ToastParams } from './types';

export class ToastManager implements IToastManager {
  #ref: RefObject<IToastManager | null> | null = null;

  connect(ref: RefObject<IToastManager | null>) {
    this.#ref = ref;
  }

  disconnect() {
    this.#ref = null;
  }

  close(toastId: ToastIdentifier): void {
    if (!this.#ref?.current) {
      throw new Error('ToastManager is not connected');
    }
    return this.#ref.current.close(toastId);
  }

  create(params: ToastParams): ToastIdentifier | null {
    if (!this.#ref?.current) {
      throw new Error('ToastManager is not connected');
    }
    return this.#ref.current.create(params);
  }
}
